/**
 * Auto-fills the reply composer with the recital type's submission template
 * when a user replies in a submission thread.
 *
 * Uses a two-stage delayed approach (150ms + 400ms) to overwrite the
 * flarum/mentions mention that gets injected into the composer. We set
 * the textarea value directly via DOM and dispatch an 'input' event
 * to keep Mithril's state in sync.
 */
import { extend } from 'flarum/common/extend';
import ReplyComposer from 'flarum/forum/components/ReplyComposer';
import { getRecitalTypeForDiscussion } from './recitalTypes';

export default function addSubmissionTemplate() {
  extend(ReplyComposer.prototype, 'oninit', function () {
    var discussion = this.attrs.discussion;
    if (!discussion) return;

    var recitalType = getRecitalTypeForDiscussion(discussion);
    if (!recitalType) return;

    var template = recitalType.submission_template;
    if (!template) return;

    this._recitalTemplate = template;
    this.composer.fields.content(template);
    this.composer.body.attrs.originalContent = template;
  });

  extend(ReplyComposer.prototype, 'oncreate', function () {
    if (!this._recitalTemplate) return;
    var template = this._recitalTemplate;
    var composer = this.composer;

    var applyTemplate = function () {
      try {
        if (!composer.editor || !composer.editor.el) return;
        composer.fields.content(template);
        composer.editor.el.value = template;
        composer.editor.el.dispatchEvent(new Event('input', { bubbles: true }));
        m.redraw();
      } catch (e) {
        // Ignore DOMException from setSelectionRange
      }
    };

    setTimeout(applyTemplate, 150);
    setTimeout(applyTemplate, 400);
  });
}
